import React, { useEffect, useState } from 'react';
import { CloudRain, Thermometer, Wind, Backpack, MapPin } from 'lucide-react';
import { getKickoffWeather } from '../lib/api';

export const KickoffWeather = ({ gameId, compact = false }) => {
  const [weather, setWeather] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!gameId) return;
    getKickoffWeather(gameId).then(setWeather).catch(() => setFailed(true));
  }, [gameId]);

  if (!gameId || failed || !weather) return null;
  const venueParts = (weather.venue || '').split(',').map((p) => p.trim()).filter(Boolean);
  const venueLabel = venueParts.length >= 3 ? `${venueParts[0]} · ${venueParts[2]}` : venueParts[0] || '';
  const kickoffLabel = weather.kickoffTime ? new Date(`${weather.date}T${weather.kickoffTime}`).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' }) : '';
  const stat = (Icon, label, value, testid) => (
    <div className="flex items-center gap-1.5 min-w-0" data-testid={`kickoff-weather-${gameId}-${testid}`}>
      <Icon className="w-3.5 h-3.5 text-[#f4b400] shrink-0" aria-hidden="true" />
      <span className="font-heading uppercase tracking-widest text-[8px] text-white/55">{label}</span>
      <span className="font-display text-base sm:text-lg text-white tabular-nums">{value}</span>
    </div>
  );

  return (
    <div data-testid={`kickoff-weather-${gameId}`} className={`border-l-4 border-[#f4b400] bg-[#102a5c] text-white ${compact ? 'px-3 py-2' : 'px-4 py-3'}`}>
      <div className="font-heading uppercase tracking-[0.3em] text-[9px] text-white/60">Forecast at kickoff{kickoffLabel ? ` ${kickoffLabel}` : ''} · {weather.condition}</div>
      {venueLabel && <div className="flex items-center gap-1 mt-0.5 text-[11px] text-[#f4b400]" data-testid={`kickoff-weather-${gameId}-venue`}><MapPin className="w-3 h-3 shrink-0" aria-hidden="true" /><span className="font-heading uppercase tracking-widest text-[9px] truncate">{venueLabel}</span></div>}
      <div className="mt-1 flex flex-wrap gap-x-4 gap-y-1">
        {stat(Thermometer, 'Temp', `${weather.temperature_f}°`, 'temp')}
        {stat(Thermometer, 'Feels', `${weather.feels_like_f}°`, 'feels')}
        {stat(CloudRain, 'Rain', `${weather.precipitation_probability_percent}%`, 'rain')}
        {stat(Wind, 'Wind', `${weather.wind_mph} mph`, 'wind')}
      </div>
      <div className="mt-1.5 flex items-start gap-1.5 text-xs text-white/85" data-testid={`kickoff-weather-${gameId}-hint`}>
        <Backpack className="w-3.5 h-3.5 mt-0.5 text-[#f4b400] shrink-0" aria-hidden="true" />
        <span><span className="font-heading uppercase tracking-widest text-[9px] text-[#f4b400] mr-1">Pack:</span>{weather.packing_hint}</span>
      </div>
    </div>
  );
};
